export const getUserToken = () => {}
export const getExpirationDate = () => {}
export const getUserFullname = () => {}
export const getUserPermissions = () => {}
export const isUserConnected = () => {}
